/* eslint-disable */

/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Drivers Portal (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Spin, Table, notification } from 'antd';
import React, { useEffect, useState } from 'react';

import { _get_wise9ja_matrix, _get_wise9ja_report } from "common/axios_services";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";

function Wise9jaReport() {
    const [spinnerLoading, setSpinnerLoading] = useState(true);
    const [wise9ja, setWise9ja] = useState([]);
    const [wise9jaMatrix, setWise9jaMatrix] = useState(false);
    const jwt = localStorage.konnect_admin_token;

    const openNotificationWithIcon = (type, message) => {
        notification[type]({
            message: '',
            placement: 'bottomRight',
            description:
                message,
        });
    };
    if (!jwt) {
        openNotificationWithIcon('error', 'Unauthorized')
        return navigate('/')
    }
    const getWise9jaReport = async () => {
        try {
            const fetchAllWise9ja = await _get_wise9ja_report()
            setSpinnerLoading(false)
            setWise9ja(fetchAllWise9ja.data.data);
        } catch (err) {
            setSpinnerLoading(false)
            if (err.response) {
                if (err.response === "Unauthorized") {
                    window.location.reload()
                    openNotificationWithIcon('error', err.response.data.message);
                } else {
                    openNotificationWithIcon('error', err.response.data.message);
                }
            } else {
                openNotificationWithIcon('error', err.message);
            }
        }
    }
    const getWise9jaMatrix = async () => {
        try {
            const wise9ja_matrix = await _get_wise9ja_matrix()
            setWise9jaMatrix(wise9ja_matrix.data.data)
        } catch (err) {
            if (err.response) {
                if (err.response.data.message === "Unauthorized") {
                    localStorage.removeItem('konnect_admin_token')
                    navigate('/')
                    openNotificationWithIcon('error', err.response.data.message)
                } else {
                    openNotificationWithIcon('error', err.response.data.message)
                }
            } else {
                openNotificationWithIcon('error', err.message)
            }
        }
    }
    useEffect(() => {
        getWise9jaReport()
        getWise9jaMatrix()
    }, [])
    let data = wise9ja.map((trans, index) => {
        return {
            key: index,
            month: trans.month,
            users: <NumericFormat thousandSeparator={true} displayType={'text'} value={Number(trans?.total_users)} />,
            inc: <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(trans?.cash_earned) * 1)} />,
            earnings: <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(trans?.cash_to_earned) * 1)} />,
            subscriptions: <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(trans?.subscription) * 1)} />,
            action: <Link to={`/report/wise9ja/${trans.created_month}`}>View</Link>,
        }
    });
    const columns = [
        {
            title: 'Month',
            dataIndex: 'month',
        },
        {
            title: 'Transaction(s)',
            dataIndex: 'users',
            align: 'center'
        },
        {
            title: 'Subscriptions (NGN)',
            dataIndex: 'subscriptions',
            align: 'right'
        },
        {
            title: 'Cash Earned (NGN)',
            dataIndex: 'inc',
            align: 'right'
        },
        {
            title: 'Cash To Earn (NGN)',
            dataIndex: 'earnings',
            align: 'right'
        },
    ];

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={4}>
                <Grid container spacing={3} pb={6}>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                color="dark"
                                icon="weekend"
                                title="Total Transactions"
                                count={wise9jaMatrix ? <NumericFormat style={{ fontSize: "16px", fontWeight: "bold" }} thousandSeparator={true} displayType={'text'} value={Number(wise9jaMatrix?.total_users)} /> : "0"}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                icon="leaderboard"
                                title="Total Subscribed"
                                count={wise9jaMatrix ? <span style={{ fontSize: "16px", fontWeight: "bold" }}> <span style={{ fontWeight: "normal", fontSize: "12px" }}>NGN</span>  <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(wise9jaMatrix?.subscription) * 1)} /> </span> : "0"}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                icon="leaderboard"
                                title="Cash Earned"
                                count={wise9jaMatrix ? <span style={{ fontSize: "16px", fontWeight: "bold" }}> <span style={{ fontWeight: "normal", fontSize: "12px" }}>NGN</span>  <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(wise9jaMatrix?.cash_earned) * 1)} /> </span> : "0"}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                icon="leaderboard"
                                title="Cash To Earn"
                                count={wise9jaMatrix ? <span style={{ fontSize: "16px", fontWeight: "bold" }}> <span style={{ fontWeight: "normal", fontSize: "12px" }}>NGN</span>  <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(wise9jaMatrix?.cash_to_earned) * 1)} /> </span> : "0"}
                            />
                        </MDBox>
                    </Grid>
                </Grid>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" >
                                <MDTypography variant="h6" color="white">
                                    Wise9ja Reports
                                </MDTypography>
                            </MDBox>
                            <MDBox py={3} px={2}>
                                <Spin tip="Loading..." spinning={spinnerLoading}>
                                    <React.Fragment>
                                        <>
                                            <div className="table-responsive">
                                                <Table columns={columns} pagination={false} dataSource={data} bordered />
                                            </div>
                                        </>
                                    </React.Fragment>
                                </Spin>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout >
    );

};

export default Wise9jaReport;